import { useState } from "react";
import { useEffect } from "react";
import { useOasisBackend } from "../../hooks/useOasisBackend";
import { Entity, EntityCollection } from "../../api/OasisBackendApi";
import IndexRequestManager from "./IndexRequestManager";

const EntityCollectionDetail = ({databaseId}: {databaseId: string}) => {
    const [entityCollection, setEntityCollection] = useState<EntityCollection | null>(null);
    const db = useOasisBackend();
    
    useEffect(() => {
        const fetchEntityCollection = async () => {
            const response = await db.endpoints.api.apiDatabaseEntityCollectionRetrieve(databaseId);
            setEntityCollection(response.data);
        }
        fetchEntityCollection();
    }, [databaseId]);

    console.log(entityCollection);

    return (
        <div>
            {entityCollection && (
                <div className="flex flex-row gap-2">
                    <IndexRequestManager databaseId={databaseId} entityCollectionId={entityCollection?.id || ""} />
                </div>
            )}
            {entityCollection?.entities && entityCollection.entities.map((entity: Entity) => (
                <div key={entity.id}>
                    <h2>Content</h2>
                    <pre>{JSON.stringify(entity.content, null, 2)}</pre>
                    <h3>Embedding</h3>
                    <pre>{JSON.stringify(entity.embedding, null, 2)}</pre>
                </div>
            ))}
        </div>
    )
}

export default EntityCollectionDetail;